import { Checkbox, LinearProgress, Typography } from "@mui/material";
import { Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import AppStackLayout from "component/AppStackLayout/AppStackLayout";
import styles from "./Documents.module.css";
import Grid from "@mui/material/Grid";
import AppButton from "component/button/AppButton";
import DocumentCard from "component/documentCard/DocumentCard";
import ModalLayout from "component/modalLayout/ModalLayout";
import DocumentUpload from "./modals/documentUpload/DocumentUpload";
import { getResponsiveDocumentModalWidth } from "utils/helpers";
import { useGetDocuments } from "api/queries/dashboard/docuements";
import EmptyState from "component/emptyState/EmptyState";
import { useCheckDocuments } from "api/queries/dashboard/docuements/Documents";
// import { useGetApplications } from "api/queries/dashboard/applications/Applications";
import documents from "utils/documents";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import Feedback from "component/feedback/Feedback";
import { useNavigate } from "react-router";

function Documents() {
  const [openDocumentsUpload, setOpenDocumentsUpload] = useState(false);
  const [width, setWidth] = useState(getResponsiveDocumentModalWidth());
  const [filteredDocs, setFilteredDocs] = useState([]);
  const [showFeedback, setShowFeedback] = useState(false);

  const { documentsCheckData, loading: loadingDocumentsCheck } =
    useCheckDocuments();

  useEffect(() => {
    if (!!documentsCheckData) {
      if (documentsCheckData?.allDocuments?.length > 0) {
        setFilteredDocs(
          documents?.filter((doc) =>
            documentsCheckData?.allDocuments?.includes(doc?.value)
          )
        );
      }
      setShowFeedback(documentsCheckData?.allowApplication);
    }
  }, [documentsCheckData]);

  useEffect(() => {
    getResponsiveDocumentModalWidth();
    window.addEventListener("resize", () => {
      setWidth(getResponsiveDocumentModalWidth());
    });
  }, []);

  const { documentsData, loading } = useGetDocuments();

  return (
    <AppStackLayout activeLink="documents">
      <div className={styles.documents}>
        <Container maxWidth="xl">
          <div className={styles.documents_content}>
            <div className={styles.heading}>
              <Grid sx={{ alignItems: "center" }} container spacing={1}>
                <Grid item xs={12} md={8}>
                  <div className={styles.heading_left}>
                    <div className={styles.heading_text}>
                      <Typography variant="h6">overview</Typography>
                      <Typography>
                        Upload required documents for your mortgage application
                        here.
                      </Typography>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} md={4}>
                  <div className={styles.documents_btn}>
                    <AppButton
                      handleAction={() => {
                        setOpenDocumentsUpload(true);
                      }}
                      width={"189px"}
                      textColor="#FFFFFF"
                      btnBg="#0089FF"
                      btnText="Upload Documents"
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
            {loading || loadingDocumentsCheck ? (
              <LinearProgress />
            ) : (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  md={8}
                  sx={{
                    paddingRight: "30px",
                  }}
                >
                  <div className={styles.body}>
                    {!!documentsData && documentsData?.data?.length > 0 ? (
                      <Grid
                        sx={{
                          alignItems: "center",
                          justifyContent: ["center", "flex-start"],
                        }}
                        container
                        spacing={"20px"}
                      >
                        {documentsData?.data?.map((document) => (
                          <Grid
                            key={document.id}
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={4}
                            xl={3}
                            height="100%"
                          >
                            <DocumentCard document={document} />
                          </Grid>
                        ))}
                      </Grid>
                    ) : (
                      <EmptyState
                        btnText="Upload Documents"
                        text="You currently do not have any documents uploaded yet, click the button below to upload a document."
                        handleClickButton={() => {
                          setOpenDocumentsUpload(true);
                        }}
                      />
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} md={4} paddingLeft={{ md: "30px" }}>
                  <DocumentList
                    documentsCheckData={documentsCheckData}
                    filteredDocs={filteredDocs}
                    setShowFeedback={setShowFeedback}
                    showFeedback={showFeedback}
                  />
                </Grid>
              </Grid>
            )}
          </div>
        </Container>
        {openDocumentsUpload && (
          <ModalLayout
            title="Mortgage Application"
            handleClose={() => {
              setOpenDocumentsUpload(false);
            }}
            width={width}
            openModal={openDocumentsUpload}
            children={
              <DocumentUpload onClose={() => setOpenDocumentsUpload(false)} />
            }
          />
        )}
      </div>
    </AppStackLayout>
  );
}

export default Documents;

const DocumentList = ({
  filteredDocs,
  showFeedback,
  setShowFeedback,
  documentsCheckData,
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.list_wrapper}>
      <div className={styles.doc_list}>
        <div className={styles.title}>
          <h3>Document Checklist</h3>
        </div>

        <ul className={styles.list}>
          {filteredDocs?.length > 0 &&
            filteredDocs.map((doc) => (
              <li key={doc?.value}>
                <Checkbox
                  className={styles.check}
                  checked={documentsCheckData?.uploadedDocuments?.includes(
                    doc?.value
                  )}
                  size="medium"
                />
                <p
                  style={{
                    textTransform: "capitalize",
                    fontSize: "12px",
                  }}
                >
                  {doc.label}
                </p>
              </li>
            ))}
        </ul>
      </div>

      <AppBackdrop
        openModal={showFeedback}
        handleCloseModal={() => setShowFeedback(false)}
        children={
          <Feedback
            btnText={"Proceed to application"}
            secondaryText="All documents have been uploaded successfully, please proceed to application"
            feedbackState={"info"}
            handleClickBtn={() => {
              navigate("/applications");
            }}
            handleClickSecondaryBtn={() => setShowFeedback(false)}
            secondaryBtn
          />
        }
      />
    </div>
  );
};